import React from "react";
import { useTranslation } from "react-i18next";

// MUI
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

// MUI Icons
import FingerprintIcon from "@mui/icons-material/Fingerprint";

// Types
type FormHeadingIDProps = {
  id?: number
}

function FormHeadingID(props: FormHeadingIDProps) {
  const { t } = useTranslation();

  const { id } = props;

  return (
    <Tooltip title={t("common.id") as string}>
      <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
        <FingerprintIcon style={{ marginRight: 8 }} />
        <Typography align="left" variant="subtitle2" className="nodrag">
          {id}
        </Typography>
      </div>
    </Tooltip>
  );
}

export default FormHeadingID;
